import { voiceProfileAPI, APIError } from "../../lib/api";
import type { VoiceProfileSummary, VoiceProfileAnalytics } from "../../types/voiceProfile";

export interface VoiceProfilePageData {
  summary: VoiceProfileSummary | null;
  analytics: VoiceProfileAnalytics | null;
  error: string | null;
}

export async function voiceProfileLoader(): Promise<VoiceProfilePageData> {
  try {
    const [summary, analytics] = await Promise.all([
      voiceProfileAPI.getSummary(),
      voiceProfileAPI.getAnalytics(),
    ]);

    return {
      summary,
      analytics,
      error: null,
    };
  } catch (error) {
    if (error instanceof APIError && error.statusCode === 404) {
      return {
        summary: null,
        analytics: null,
        error: null,
      };
    }

    const errorMessage = error instanceof APIError ? error.message : "Failed to load voice profile";

    return {
      summary: null,
      analytics: null,
      error: errorMessage,
    };
  }
}
